// extracted by mini-css-extract-plugin
export var container = "_c7-0";
export var icon = "_c7-1";
export var text = "_c7-2";